import React, {useEffect, useState} from 'react';
import WorkingCuttingMapTable from "../../../../components/UI/table/cutting/workingcuttingmap/WorkingCuttingMapTable";
import WorkingCuttingMapService from "../../../../API/orders/cutting/cuttingmap/WorkingCuttingMapService";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";
import Typography from "@mui/material/Typography";
import {constantsErrorMessages} from "../../../../Constants";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {useLocation} from "react-router-dom";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {WorkingCuttingMapTableFilterData} from "../../../../data/FilterTables/WorkingCuttingMapTableFilterData";

const WorkingCuttingMaps = () => {
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, WorkingCuttingMapTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [WorkingCuttingMapTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(pathname, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        const searchQuery = pagesData[pathname]?.searchQuery

        return {searchQuery, pageSize}
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        WorkingCuttingMapService.getAll().then(function (response) {
            const data = response.data;
            setData(data);
            handleSearchQuery(searchQuery, data, pageSize)
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Карты раскроя"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Карты раскроя
                    </Typography>
                </Box>
                <WorkingCuttingMapTable
                    data={data}
                    setData={setData}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    enableRowSelection={true}
                    globalFilter={globalFilter}
                    filteredData={filteredData}
                    handleSearchQuery={handleSearchQuery}
                    columnsFilter={columnsFilter}
                />
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                    autoHide={false}
                />
            </Box>
        </Box>
    );
};

export default WorkingCuttingMaps;